import { createFileRoute, Outlet } from '@tanstack/react-router';
import { createCaslGuard } from '@/lib/auth/permissionGuards';

export const Route = createFileRoute('/$slug/processes/process-chains')({
  beforeLoad: createCaslGuard('ProcessChain'),
  component: Outlet
});
